package ca.derekellis.reroute.db

import kotlin.Double
import kotlin.Long
import kotlin.String

public data class Stops(
  public val id: String,
  public val code: String,
  public val name: String,
  public val desc: String?,
  public val lat: Double,
  public val lon: Double,
  public val zone_id: Long?,
  public val url: String?,
  public val location_type: Long,
)
